import React from 'react';

import { gql } from '@apollo/client';
import { Trans, useTranslation } from '@modernloop/i18n';
import { FCWithFragments } from '@modernloop/shared/components';
import { Alert, Stack, Typography } from '@mui/material';

import { ApplicationConflict_TaskFragment } from 'src/generated/mloop-graphql';

type Fragments = {
  task: ApplicationConflict_TaskFragment;
};

const ApplicationConflict: FCWithFragments<Fragments> = ({ task }) => {
  // Subscribes this component to language changes; the strings render via <Trans>.
  useTranslation();
  const isTaskAndApplicationConflict = task.jobStage?.job?.id !== task.application.jobStage?.job?.id;

  if (!isTaskAndApplicationConflict || !task.jobStage) {
    return null;
  }

  return (
    <Stack>
      <Alert severity="error">
        <Typography variant="body2">
          <Trans
            i18nKey="hiring-dashboard-candidates:candidates.applicationConflict.message"
            values={{
              taskJobName: task.jobStage?.job?.name,
              applicationJobName: task.application.jobStage?.job?.name,
            }}
            components={{ bold: <Typography component="span" variant="subtitle2" /> }}
          />
        </Typography>
      </Alert>
    </Stack>
  );
};

ApplicationConflict.fragments = {
  task: gql`
    fragment ApplicationConflict_task on Task {
      id
      jobStage {
        id
        job {
          id
          name
        }
      }
      application {
        id
        jobStage {
          id
          job {
            id
            name
          }
        }
      }
    }
  `,
};

export default ApplicationConflict;
